/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PublicInstrument interface.
 */
export function instanceOfPublicInstrument(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('color' in value) || value['color'] === undefined)
        return false;
    return true;
}
export function PublicInstrumentFromJSON(json) {
    return PublicInstrumentFromJSONTyped(json, false);
}
export function PublicInstrumentFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'color': json['color'],
    };
}
export function PublicInstrumentToJSON(json) {
    return PublicInstrumentToJSONTyped(json, false);
}
export function PublicInstrumentToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'color': value['color'],
    };
}
